import React, { useState } from "react";
import { useSelector } from "react-redux";
import WithDatesSearchComponent from "./withDatesSearch.component";

export default function WithDatesSearchContainer({
  handleFilter
}) {
  const lang = useSelector(state => state.constant.languages)
  const [registeredDate, setRegisteredDate] = useState();
  const [verifiedDate, setVerifiedDate] = useState();
  const [clearDate, setClearDate] = useState(false);

  const handleSearch = async (search) => {
    await handleFilter({
      search: search,
      registeredDate: registeredDate,
      verifiedDate: verifiedDate
    });
  };

  const handleClear = async () => {
    setRegisteredDate(null);
    setVerifiedDate(null);
    setClearDate(true);
    await handleFilter({
      search: "",
      registeredDate: null,
      verifiedDate: null
    });
    setClearDate(false);
  }

  return <WithDatesSearchComponent
    handleSearch={handleSearch}
    lang={lang}
    registeredDate={registeredDate}
    setRegisteredDate={setRegisteredDate}
    verifiedDate={verifiedDate}
    setVerifiedDate={setVerifiedDate}
    handleClear={handleClear}
    clearDate={clearDate}
  />
}
